import React, { useState, useEffect, useContext, Component,useRef } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
 
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
 
// import required modules
import { Pagination, Navigation,Autoplay } from 'swiper/modules';

import { useBlogContext } from '../../fetchdata/BlogContext';
import HeaderNew from '../components/HeaderNew';
import CreateSlug from "../components/extra/CreateSlug";

const HomeCartLocation = () => {

  const navigate = useNavigate();

    const { 
      isLayoutLoading,
      layout,  removeItemFromCart, updateItemQuantity,  addItemToCart,     cartItems,
    } = useBlogContext();
  const [TotalQuantity, setTotalQuantity] = useState(1);


      const handleAddToCart = async (product, buy) => {
        // if (!selectedColor) {
        //   toast.error("Please select a color");
        // } else if (!TotalQuantity) {
        //   toast.error("Please select a Quantity", TotalQuantity);
        // } else { }
    
        const existingProduct = cartItems.find((item) => item.id === product.id);
        if (existingProduct) {
          // const updatedQuantity = existingProduct.quantity + 1;
          const updatedQuantity = TotalQuantity;
          console.log("updatedQuantity", updatedQuantity);
    
          updateItemQuantity(
            existingProduct.id,
            cartItems.find((item) => item.id === existingProduct.id).quantity +
            updatedQuantity
          );
    
          if (buy) {
            navigate("/checkout");
          }
          toast.success("Product quantity updated in cart");
        } else {
          await addItemToCart(
            { ...product, TotalQuantity },
            TotalQuantity
          );
    
          // updateItemQuantity(product.id, updatedQuantity);
    
          if (buy) {
            navigate("/checkout");
          }
          // toast.success("Product Added To Cart");
        }
      };
    

  const swiperRefLocal = useRef()

  const handleMouseEnter = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.stop()
  };

  const handleMouseLeave = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.start()
  };


  const [loading, setloading] = useState(true);

  const [Data, setData] = useState([]);
  const { slug } = useParams();

     const [defaultState, setdefaultState] = useState('delhi');
   
 const getBlog = async () => {
 
       
        setloading(true);
        try {
          const { data } = await axiosInstance.get(`/get-catgeory-product?location=${ defaultState }`);
          setData(data.categoriesWithProducts || []);
          // Delay the execution of buildScript by 1 secon
          console.log('datadata',data);
    
        }
        catch (error) {
          console.log(error);
          // toast.error("Error fetching Single Blog!");
        } finally {
          setloading(false);
        }
    
    
 };
     
  // useEffect(() => {
  //   getBlog();
  //    window.scrollTo(0, 0);
  // }, [slug]);


  useEffect(() => {
     const location = localStorage.getItem('location');
     let stateSlug  = 'delhi';
    if( location !== "[object Object]" && location){
        stateSlug = CreateSlug(location);
     } 
     window.scrollTo(0, 0);

     setdefaultState(stateSlug);
     getBlog();
  }, []);

  const handleDecreaseQuantity = (itemId) => {
  const item = cartItems.find(item => item.id === itemId);
  if (!item) return; // Prevent errors if item not found

  const newQuantity = item.quantity - 1;

  if (newQuantity < 1) {
    removeItemFromCart(itemId); // Call remove function
  } else {
    updateItemQuantity(itemId, newQuantity);
  }
};

  const handleIncreaseQuantity = (itemId) => {
    updateItemQuantity(itemId, cartItems.find(item => item.id === itemId).quantity + 1);
  };

  return (
    <>
      <HeaderNew />
   



<main class="container my-4">
     
{loading ? <> 

  <div className='d-flex justify-content-center align-items-center' style={{minHeight:'80vh'}}>
  <div class="spinner-border" role="status" style={{width:100,height:100}}>
 </div>
</div>

</> : 
<>
{Data.length === 0 ?
<>
<div className='d-flex justify-content-center align-items-center' style={{minHeight:'80vh'}}>
  <div className='text-center'>
  <h1>Oops! That page can't be found.
  </h1>
  <p>It looks like nothing was found at this location. Maybe try a search?</p>
  <Link to="/" className='btn btn-primary'> GO HOME</Link>
  </div>
</div>

</>
:
<>

   {/* HERO */}
  <div className="hero mb-4 d-none">
    <div className="row align-items-center g-3">
      <div className="col-md-8">
        <h2 className="mb-1">Paan corner</h2>
        <p className="mb-3">Your favourite paan shop is now online</p>
        <button className="btn btn-light-soft btn-sm px-3">Shop Now</button>
      </div>
      <div className="col-md-4 text-md-end">
        {/* decorative items could be placed here if needed */}
      </div>
    </div>
  </div>
  {/* PROMO TILES */}
  <div className="row g-3 mb-4 d-none">
    <div className="col-12 col-md-4">
      <div className="promo-tile h-100 bg-info-subtle">
        <div className="promo-body">
          <div className="promo-title">Pharmacy at your doorstep!</div>
          <div className="promo-sub">
            Cough syrups, pain relief sprays &amp; more
          </div>
          <a className="btn btn-sm btn-light-soft mt-3">Order Now</a>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-4">
      <div className="promo-tile h-100 bg-warning-subtle">
        <div className="promo-body">
          <div className="promo-title">Pet Care supplies in minutes</div>
          <div className="promo-sub">Food, treats, toys &amp; more</div>
          <a className="btn btn-sm btn-light-soft mt-3">Order Now</a>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-4">
      <div className="promo-tile h-100 bg-light">
        <div className="promo-body">
          <div className="promo-title">No time for a diaper run?</div>
          <div className="promo-sub">Get baby care essentials in minutes</div>
          <a className="btn btn-sm btn-outline-dark mt-3">Order Now</a>
        </div>
      </div>
    </div>
  </div>

<div className='row g-3 mb-4'>
{Data.map((category, index) => (
    <div className="col-md-1 mb-4 col-3">

  <Link to={`/shop/${defaultState}/${category.slug}`} className=" d-block text-decoration-none small rounded border overflow-hidden" key={index} style={{backgroundColor:'#f8f8ff'}}>
    <img
      src={category.image ?? `https://dummyimage.com/100x100/ffffff/cccccc.png&text=${category.title || 'Category'}` }
      alt={category.title || 'Category'}
      className="w-100 object-fit-cover"  style={{aspectRatio:'1/1'}}
    />
   <span className=' text-truncate px-2 d-block text-center pb-1'> {category.title} </span> 
  </Link>
   
  </div>
))}

</div>


 
 {Data.map((category, index) => (
  <div key={index}>
  {/* SECTION: Snacks & Munchies (sample) */}
  <div className="d-flex align-items-center justify-content-between mt-5 mb-2">
    <h5 className="section-title mb-0"> {category.title} </h5>
    <Link to={`/shop/${defaultState}/${category.slug}`}  className="see-all">
      see all
    </Link>
  </div> 
  <div className="row g-3">
    {category.products.map((product, index)  => {
        const cartItem = cartItems.find(item => item.id === product._id);
  const quantity = cartItem ? cartItem.quantity || 1 : 0;
  return (
 <div className="col-6 col-md-3 col-lg-2" key={index}>
      <div className="p-card shadow">
          <Link to={`/product/${product.slug}`}  className="p-img-wrap p-2">
       
          <img
            className="w-100 rounded object-fit-cover" style={{aspectRatio:'1/0.7'}}
            src={product.pImage ?? 'Not Found'}
            alt=""
          />
            
        </Link>
        <div className='px-2'>
           <span className="tag-time">
            <i className="bi bi-lightning-charge-fill tiny" />Fast
          </span>
          </div>
        
        <div className="p-body">
              <Link to={`/product/${product.slug}`}   className="p-title text-truncate mb-2 d-block"> {product.title ?? 'Not Found'} </Link>
    
          <div className="p-foot mt-0">
            <div>
              <span className="price">₹{product.salePrice}</span>
            </div>
             {quantity > 0 ? 
               <div className="add-btn d-inline-flex align-items-center gap-2" style={{backgroundColor:'var(--blink-green)'}} >
             
                     <button className="border-0 bg-transparent p-0 h6 text-white m-0"  type='button'  onClick={() => handleDecreaseQuantity(product._id)}>−</button>


 <span className='text-white fw-bold'>   {quantity} </span>

           <button className="border-0 bg-transparent p-0 h6 text-white m-0"  type='button' 
            onClick={() => handleIncreaseQuantity(product._id)}>+</button>


 
            </div> : 
              <button className="add-btn" onClick={()=>{
                 handleAddToCart({  id: product._id ,
                                  title: product.title ,
                                  image: product.pImage,
                                  regularPrice: product.regularPrice,
                                  price: product.salePrice,
                                  gst: product.gst,
                                  stock: product.stock,
                                  pid: product._id,
                                });
              }}>
             
        
<span  > Add
</span> 
 
            </button>
              } 
          
          </div>
        </div>
      </div>
    </div>
  )
 
})}
   
   </div>

  </div>
))}
  

</>

}





</>
}
    
       
    


      </main>



 
      <Footer />
    </>

  )
}

export default HomeCartLocation